interface IIconProps {
  size?: number;
  color?: string;
  circleColor?: string;
}

export const AssociateDentistIcon = ({ size = 48, color = '#83B2BE', circleColor = '#E7F0F3' }: IIconProps) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24.0002" cy="23.9997" r="22.8571" fill={circleColor} />
    <g clipPath="url(#clip0_861_10757)">
      <path
        d="M28.9312 24.5C33.2505 24.8944 36.6332 28.7224 36.6333 32.9473C36.6333 37.1723 33.5442 37.3789 29.5024 37.3789C29.0616 37.3789 28.6097 37.377 28.1489 37.377H19.4146C18.953 37.377 18.5011 37.3789 18.0601 37.3789C14.019 37.3789 10.9321 37.3698 10.9321 32.9473C10.9323 28.5249 14.3147 24.8949 18.6333 24.501C18.6689 26.0478 23.7837 29.8652 23.7837 29.8652C23.8297 29.8309 28.8971 26.0402 28.9312 24.5ZM29.4038 29.4287C29.0578 29.4288 28.8887 29.5963 28.8882 29.9395C28.8878 30.3802 28.8882 31.0179 28.8882 31.4834H27.3257C27.0096 31.4846 26.8343 31.6599 26.8335 31.9756V33.2441C26.8347 33.5626 27.0063 33.7332 27.3247 33.7344H28.8892C28.8892 34.2075 28.8884 34.8541 28.8892 35.3047C28.8899 35.6124 29.0611 35.7879 29.3706 35.79H30.6548C30.968 35.7885 31.1388 35.61 31.1401 35.291V33.7344H31.3179C31.7197 33.7344 32.3174 33.7357 32.7192 33.7334C33.0153 33.7318 33.1938 33.5525 33.1938 33.2549V31.9717C33.1931 31.6666 33.0144 31.4854 32.7104 31.4834C32.3085 31.481 31.7109 31.4824 31.3091 31.4824H31.1401V29.918C31.1384 29.6057 30.958 29.4287 30.644 29.4287H29.4038Z"
        fill={color}
      />
      <path
        d="M23.7847 25.6097C27.6911 25.6097 30.8577 19.7355 30.8577 15.8292C30.8577 11.9228 27.6917 8.75684 23.7847 8.75684C19.8777 8.75684 16.7124 11.9234 16.7124 15.8292C16.7124 19.7349 19.879 25.6097 23.7847 25.6097Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_861_10757">
        <rect width="25.701" height="28.6222" fill="white" transform="translate(10.9321 8.75684)" />
      </clipPath>
    </defs>
  </svg>
);
